// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__3vnlE","column":"style_column__NyUwE","row":"style_row__3Osnf"};